import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateUser, getCurrentUser } from '../../../api';
import { getUserInfo } from '../../../utils/auth';
import { AuthService } from '../../../services';
import CommonTitle from '../../../components/common-title/CommonTitle';

function EditInfoPC() {
  const navigate = useNavigate();
     const [formData, setFormData] = useState({
     nickname: '',
     password: '',
     confirmPassword: '',
     bongandangId: 1,
     name: '',
     email1: '',
     email2: '',
     emailDomain: '',
     sex: '남',
     birthday: '',
     phone1: '',
     handphone1: '010',
     handphone2: '',
     handphone3: '',
     postCode: '',
     address1: '',
     address2: ''
   });

  const [idCheckResult, setIdCheckResult] = useState("사용 가능한 ID입니다");
  const [idCheckStatus, setIdCheckStatus] = useState("success");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [places, setPlaces] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);

  // Single alert function for validation messages (similar to SignupPC.jsx)
  const showValidationAlert = (message) => {
    alert(message);
  };

  useEffect(() => {
    // Use hardcoded places list to match the correct options
    setPlaces([
      { id: 1, name: "가족묘" },
      { id: 2, name: "봉안담" },
      { id: 3, name: "봉안당 A관" },
      { id: 4, name: "봉안당 S관" },
      { id: 5, name: "봉안당 하늘관" },
      { id: 6, name: "봉안당 햇빛관" },
      { id: 7, name: "야외가족납골당" }
    ]);

    // Load Daum Postcode script
    if (!window.daum) {
      const script = document.createElement('script');
      script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
      script.async = true;
      document.body.appendChild(script);
    }

    // Load user data
    loadUserData();
  }, []);

  const loadUserData = async () => {
    try {
      setDataLoading(true);
      
      // Get user ID from localStorage (from login response)
      const userInfo = getUserInfo();
      const userId = userInfo?.id || userInfo?.userId;
      
      // Try to get user data from API first
      let userData = null;
      try {
        if (userId) {
          const response = await getCurrentUser(userId);
          userData = response.data;
        } else {
          throw new Error('No user ID found');
        }
      } catch (apiError) {
        console.warn('Failed to load user data from API, using localStorage:', apiError);
        // Fallback to localStorage data
        userData = userInfo;
      }

      if (userData) {        
        // Parse email into components
        let email1 = '', email2 = '', emailDomain = '';
        if (userData.email) {
          const emailParts = userData.email.split('@');
          if (emailParts.length === 2) {
            email1 = emailParts[0];
            email2 = emailParts[1];
            emailDomain = emailParts[1];
          }
        }

                 // Parse phone numbers - now just use the full phone number
         let phone1 = '';
         if (userData.phone) {
           phone1 = userData.phone; // Use the full phone number as is
         }

        // Parse handphone numbers
        let handphone1 = '010', handphone2 = '', handphone3 = '';
        if (userData.handphone) {
          const handphoneStr = userData.handphone.replace(/-/g, '');
          if (handphoneStr.length >= 10) {
            handphone1 = handphoneStr.substring(0, 3);
            handphone2 = handphoneStr.substring(3, 7);
            handphone3 = handphoneStr.substring(7);
          }
        }

           // Remove dashes from birthday to ensure YYYYMMDD format
           let birthday = userData.birthday || '';
           if (birthday) {
             birthday = birthday.replace(/-/g, ''); // Remove all dashes
           }

           setFormData({
           nickname: userData.nickname || '',
           password: '',
           confirmPassword: '',
           bongandangId: userData.bongandangId || 1,
           name: userData.name || '',
           email1: email1,
           email2: email2,
           emailDomain: emailDomain,
           sex: userData.gender || '남', // Try both sex and gender fields
           birthday: birthday,
           phone1: phone1, // Now contains the full phone number
           handphone1: handphone1,
           handphone2: handphone2,
           handphone3: handphone3,
           postCode: userData.postCode || '',
           address1: userData.address1 || '',
           address2: userData.address2 || ''
         });
      }
    } catch (error) {
      console.error('Error loading user data:', error);
      setError('사용자 정보를 불러오는데 실패했습니다.');
    } finally {
      setDataLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Special handling for birthday field - only allow numeric input and max 8 characters
    if (name === 'birthday') {
      const numericValue = value.replace(/[^0-9]/g, '').slice(0, 8);
      setFormData(prev => ({
        ...prev,
        [name]: numericValue
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
    
    // Clear errors when user types
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    setError(''); // Clear general error
  };

  const handleEmailDomain = (e) => {
    const selectedDomain = e.target.value;
    setFormData((prev) => ({ 
      ...prev, 
      emailDomain: selectedDomain,
      email2: selectedDomain === '직접 입력하기' ? prev.email2 : selectedDomain
    }));
  };

  const openPostcodePopup = () => {
    if (!window.daum || !window.daum.Postcode) {
      alert("주소 검색 서비스를 불러오는 중입니다. 잠시 후 다시 시도해주세요.");
      return;
    }
    new window.daum.Postcode({
      oncomplete: function(data) {
        // Fill postCode and address1 automatically
        // address2 will remain empty for user input only
        setFormData(prev => ({
          ...prev,
          postCode: data.zonecode,
          address1: data.roadAddress || data.jibunAddress,
          address2: "" // Keep empty for user input only
        }));
      }
    }).open();
  };

  // Password validation helper function (similar to SignupPC.jsx)
  const isPasswordValid = (password) => {
    if (!password) return false;
    if (password.length < 6 || password.length > 10) return false;
    // Allow alphanumeric and special characters
    const passwordRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
    return passwordRegex.test(password);
  };
  const isPhoneValid = (phone) => /^\d{8,10}$/.test(phone.replace(/-/g, ""));
  const isSexValid = (sex) => sex === "남" || sex === "여";
  
  // Helper function to check if phone contains combination of English letters and numbers
  const isAlphanumericCombination = (phone) => {
    // Must contain both letters and numbers, and only letters and numbers
    const hasLetter = /[a-zA-Z]/.test(phone);
    const hasNumber = /\d/.test(phone);
    const onlyAlphanumeric = /^[a-zA-Z0-9]+$/.test(phone);
    return hasLetter && hasNumber && onlyAlphanumeric;
  };

  const validateForm = () => {
    const newErrors = {};

    if(!formData.password) {
      showValidationAlert('비밀번호를 입력해주세요. (6~10자 영문, 숫자, 특수기호 사용 가능)');
      return false;
    }

    // 비밀번호 validation (similar to SignupPC.jsx)
    if (formData.password && !isPasswordValid(formData.password)) {
      showValidationAlert('비밀번호를 입력해주세요. (6~10자 영문, 숫자, 특수기호 사용 가능)');
      return false;
    }

    // 비밀번호 확인 validation (similar to SignupPC.jsx)
    if (formData.password && !formData.confirmPassword) {
      showValidationAlert('비밀번호 확인을 해주세요.');
      return false;
    }

    if (formData.password && formData.confirmPassword && formData.password !== formData.confirmPassword) {
      showValidationAlert('비밀번호가 일치하지 않습니다.');
      return false;
    }

    // 이메일 validation
    if (!formData.email1 || !formData.email1.trim()) {
      showValidationAlert('도메인을 입력해주세요.');
      return false;
    }

    if (!formData.email2 && !formData.emailDomain) {
      showValidationAlert('도메인을 입력해주세요.');
      return false;
    }
    // Final email format validation
    const email = `${formData.email1}@${formData.email2 || formData.emailDomain}`;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showValidationAlert('올바른 이메일 형식을 입력해주세요');
      return false;
    }

    
    // 연락처 validation
    const phone = formData.phone1;
    if (phone) {
      // Check length first
      if (phone.length > 10) {
        showValidationAlert('영문+숫자 10자리 미만');
        return false;
      }
      
      // Check if it contains combination of English letters and numbers
      if (!isAlphanumericCombination(phone)) {
        showValidationAlert('영문+숫자 10자리 미만');
        return false;
      }
    }

    // 생년월일 validation
    if (formData.birthday && formData.birthday.length !== 8) {
      showValidationAlert('생년월일은 8자리 숫자로 입력해주세요.');
      return false;
    }

    if (formData.birthday && !/^\d{8}$/.test(formData.birthday)) {
      showValidationAlert('생년월일은 8자리 숫자로 입력해주세요.');
      return false;
    }

    // 휴대전화 validation
    const handphone = `${formData.handphone1}${formData.handphone2}${formData.handphone3}`;
    
    if (!formData.handphone2 || !formData.handphone3) {
      showValidationAlert('휴대전화번호를 입력하세요. (8~11자 숫자 사용 가능)');
      return false;
    }


    const mobileRegex = /^\d{8,11}$/;
    if (!mobileRegex.test(handphone)) {
      showValidationAlert('휴대전화번호를 입력하세요. (8~11자 숫자 사용 가능)');
      return false;
    }

    // 주소 validation
    if (!formData.postCode || !formData.postCode.trim()) {
      showValidationAlert('우편번호를 입력해주세요.');
      return false;
    }

    if (!formData.address1 || !formData.address1.trim()) {
      showValidationAlert('우편번호를 입력해주세요.');
      return false;
    }

    if (!formData.address2 || !formData.address2.trim()) {
      showValidationAlert('상세주소를 입력해주세요.(5~50자)');
      return false;
    }

    if (formData.address2.length < 5 || formData.address2.length > 50) {
      showValidationAlert('상세주소를 입력해주세요.(5~50자)');
      return false;
    }


    if (!isSexValid(formData.sex)) {
      newErrors.sex = '성별은 남 또는 여여야 합니다';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!validateForm()) {
      return;
    }

         // Compose email and phone fields
     const email = `${formData.email1}@${formData.email2 || formData.emailDomain}`;
     const phone = formData.phone1; 
     const handphone = `${formData.handphone1}${formData.handphone2}${formData.handphone3}`;

    setLoading(true);
    const targetData = {
      nickname: formData.nickname,
      password: formData.password || undefined, // Only send if changed
      confirmPassword: formData.confirmPassword || undefined,
      bongandangId: Number(formData.bongandangId),
      name: formData.name,
      email,
      sex: formData.sex,
      birthday: formData.birthday,
      phone,
      handphone,
      postCode: formData.postCode,
      address1: formData.address1,
      address2: formData.address2
    };
    
    try {
      const userInfo = getUserInfo();
      const userId = userInfo?.id || userInfo?.userId;
      const apiData = {
        id: userId,
        data: targetData
      }
   const response = await AuthService.editMyInfo(apiData);

      if(response) {    
       alert("정보가 성공적으로 수정되었습니다!");
      navigate('/');
      }
    } catch (err) {
      alert("정보 수정에 실패했습니다. 입력값을 확인하세요.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-info-pc">     
      <div className="edit-info-container">
        <div className="edit-title-container-pc">
       
          <CommonTitle heading="내 정보 수정하기" />
          <div className="subtitle-container-pc">
          <span className="subtitle">* 기본(필수)정보 입력</span>
          </div>

        </div>

        {dataLoading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>사용자 정보를 불러오는 중...</p>
          </div>
        ) : (
        <form onSubmit={handleSubmit} className="edit-form">
          <div className="edit-form-row">
            <label>아이디 <span className="required-asterisk">*</span></label>
            <div className="input-group"
              style={{margin: '6px 62% -7px 122px'}}
             >

              <input
                type="text"
                name="nickname"
                value={formData.nickname}
                onChange={handleChange}
                required
                disabled
              />
            </div>
          
          </div>
          <div className="border-bottom-id"></div>


          <div className="form-row-edit-pc">
            <label>비밀번호 <span className="required-asterisk">*</span></label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="변경하려면 입력하세요"
              disabled={loading}
            />
            <div className="hint">6~10자 영문, 숫자, 특수기호 사용 가능</div>
            {errors.password && (
              <div className="error-message">
                <span className="error-icon">!</span>
                {errors.password}
              </div>
            )}
          </div>

          <div className="form-row-edit-pc">
            <label>비밀번호 확인 <span className="required-asterisk">*</span></label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="비밀번호 확인"
            />
            {errors.confirmPassword && (
              <div className="error-message">
                <span className="error-icon">!</span>
                {errors.confirmPassword}
              </div>
            )}
          </div>

          <div className="form-row-edit-pc">
            <label>봉안당</label>
            <div className='bongandang-select'>
            <select name="bongandangId" value={formData.bongandangId} onChange={handleChange}>
              <option value="">선택해주세요</option>
              <option value="1">가족묘</option>
              {places.map(place => (
                <option key={place.id} value={place.id}>{place.name}</option>
              ))}
            </select>
            </div>
          </div>

          <div className="form-row-edit-pc">
            <label>이름(실명) <span className="required-asterisk">*</span></label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              disabled
            />
          </div>

          <div className="form-row-edit-pc">
            <label>이메일 <span className="required-asterisk">*</span></label>
            <div className="email-group">
              <div className="email-group-input">
              <input
                type="text"
                name="email1"
                value={formData.email1}
                onChange={handleChange}
                placeholder="이메일"
              />
              </div>
              <span className="at-symbol">@</span>
              <div className="email-group-input email-group-input-email2">
              <input
                type="text"
                name="email2"
                value={formData.email2}
                onChange={handleChange}
                placeholder="도메인"
                disabled={formData.emailDomain !== '직접 입력하기' && formData.emailDomain !== ''}
                className={formData.emailDomain !== '직접 입력하기' && formData.emailDomain !== '' ? 'disabled-input' : ''}
              />
              </div>
               <div className="email-group-input">
              <select name="emailDomain" value={formData.emailDomain} onChange={handleEmailDomain}>
              <option value="">선택해주세요</option>
                <option value="gmail.com">gmail.com</option>
                <option value="naver.com">naver.com</option>
                <option value="daum.net">daum.net</option>
                <option value="hanmail.net">hanmail.net</option>
                <option value="nate.com">nate.com</option>
                <option value="paran.comdreamwiz.com">paran.comdreamwiz.com</option>
                <option value="hotmail.com">hotmail.com</option>
                <option value="lycos.co.kr">lycos.co.kr</option>
                <option value="freechal.com">freechal.com</option>
                <option value="hanafos.comkorea.com">hanafos.comkorea.com</option>
                <option value="hanmir.com">hanmir.com</option>
                <option value="empal.com">empal.com</option>
                <option value="직접 입력하기">직접 입력하기</option>
              </select>
              </div>
            </div>
          </div>

          <div className="form-row-edit-pc">
            <label>성별</label>
            <div className="radio-group">
              <label className="radio-label">
                <input
                  type="radio"
                  name="sex"
                  value="남"
                  checked={formData.sex === '남'}
                  onChange={handleChange}
                />
                <span className="radio-custom"></span>
                남
              </label>
              <label className="radio-label">
                <input
                  type="radio"
                  name="sex"
                  value="여"
                  checked={formData.sex === '여'}
                  onChange={handleChange}
                />
                <span className="radio-custom"></span>
                여
              </label>
            </div>
          </div>

          <div className="form-row-edit-pc">
            <label>생년월일</label>
            <input
              type="text"
              name="birthday"
              value={formData.birthday}
              onChange={handleChange}
              placeholder="예) 19800101"
              maxLength="8"
              pattern="[0-9]*"
              inputMode="numeric"
            />
            <div style={{marginLeft:'10px'}} className="hint">예) 19800101</div>

          </div>

          <div className="form-row-edit-pc">
            <label>연락처</label>
            <input
              type="text"
              name="phone1"
              value={formData.phone1}
              onChange={handleChange}
            />
       
            <div className="hint">영문+숫자 10자리 미만</div>
          </div>

          <div className="form-row-edit-pc">
            <label>휴대전화 *</label>
            <div className="phone-group">
              <div className="phone-group-input">
              <select name="handphone1" value={formData.handphone1} onChange={handleChange}>
                <option value="010">010</option>
                <option value="011">011</option>
                <option value="016">016</option>
                <option value="017">017</option>
                <option value="018">018</option>
                <option value="019">019</option>
              </select>
              </div>
              <span className="phone-separator">-</span>
              <div className="phone-group-input">
              <input
                type="text"
                name="handphone2"
                value={formData.handphone2}
                onChange={handleChange}
                maxLength="4"
              />
              </div>
              <span className="phone-separator">-</span>
              <div className="phone-group-input">
              <input
                type="text"
                name="handphone3"
                value={formData.handphone3}
                onChange={handleChange}
                maxLength="4"
              />
              </div>
            </div>
            {errors.handphone && (
              <div className="error-message">
                <span className="error-icon">!</span>
                {errors.handphone}
              </div>
            )}
          </div>

                     <div className="form-row-edit-pc">
             <label>주소 <span className="required-asterisk">*</span></label>
             <div className="address-container edit-address-container">
               <div className="address-row-edit-pc">
                 <input
                   type="text"
                   name="postCode"
                   value={formData.postCode}
                   onChange={handleChange}
                   placeholder="우편번호"
                 />
                 <button type="button" className="postal-btn" onClick={openPostcodePopup}>우편번호</button>
               </div>
               <div className="address-detail-row flex-address-detail-row">
                 <input
                   type="text"
                   name="address1"
                   value={formData.address1}
                   onChange={handleChange}
                   placeholder="주소"
                 />
                 <input
                   type="text"
                   name="address2"
                   value={formData.address2}
                   onChange={handleChange}
                   placeholder="상세주소"
                 />
               </div>
             </div>
           </div>

          {error && (
            <div className="error-message" style={{ marginBottom: '15px' }}>
              {error}
            </div>
          )}
          <div className="form-actions">
            <button type="button" className="withdraw-btn" disabled={loading}>회원탈퇴</button>
            <div className="right-buttons">
              <button type="button" className="cancel-btn" onClick={() => navigate('/')} disabled={loading}>취소</button>
              <button type="submit" className="modify-btn" disabled={loading}>
                {loading ? "수정 중..." : "수정"}
              </button>
            </div>
          </div>
        </form>
        )}
      </div>
      
    </div>
  );
}

export default EditInfoPC; 